import { useMemo } from 'react';
import cx from 'classnames';
import { lowerCase } from 'lodash';
import PropTypes from 'prop-types';

import { IconUpload } from 'src/assets/icons/Upload';
import { CUSTOM_BUTTON_VARIANT, CustomButton } from 'src/components/CustomButton';
import { RESOURCE_CONTENT_TYPE } from 'src/data/performance';

import { EmptyMenuState } from '../EmptyMenuState';
import { ItemsImage } from '../ItemsImage';

import { useStyles } from './useStyles';

const propTypes = {
  className: PropTypes.string,
  imageResources: PropTypes.arrayOf(PropTypes.shape()).isRequired,
  onAction: PropTypes.func.isRequired,
  onUploadClick: PropTypes.func.isRequired,
  quickSearchMode: PropTypes.bool,
  searchTerm: PropTypes.string,
  noTags: PropTypes.bool,
};

const defaultProps = {
  className: '',
  quickSearchMode: false,
  searchTerm: null,
  noTags: false,
};

export const MenuContentImage = ({
  className,
  imageResources,
  onAction,
  onUploadClick,
  quickSearchMode,
  searchTerm,
  noTags,
}) => {
  const styles = useStyles();

  const filteredResources = useMemo(() => {
    if (!searchTerm) {
      return imageResources;
    }

    const preparedSearchText = lowerCase(searchTerm);

    return imageResources.filter(
      (resource) =>
        lowerCase(resource.name).includes(preparedSearchText) ||
        lowerCase(resource.content).includes(preparedSearchText)
    );
  }, [imageResources, searchTerm]);

  return (
    <div className={cx(styles.root, className)}>
      <CustomButton
        onClick={() => onUploadClick(RESOURCE_CONTENT_TYPE.image)}
        startIcon={<IconUpload />}
        variant={CUSTOM_BUTTON_VARIANT.outlined}
      >
        Upload
      </CustomButton>

      {filteredResources.length > 0 ? (
        <ItemsImage
          imageResources={filteredResources}
          onAction={onAction}
          quickSearchMode={quickSearchMode}
          noTags={noTags}
        />
      ) : (
        <EmptyMenuState
          searchText={searchTerm}
          emptyText="No images yet"
        />
      )}
    </div>
  );
};

MenuContentImage.displayName = 'MenuContentImage';
MenuContentImage.propTypes = propTypes;
MenuContentImage.defaultProps = defaultProps;
